<template lang="pug">
  v-footer.elevation-0.layout-footer(id="mainFooter" height="auto" :style="{'padding-left': paddingLeft}" app)
    v-layout.pl-3.my-3(hidden-xs-only align-center wrap)
      v-flex(style="min-width: 400px")
        span 24 小時服務專線&nbsp;
          a(:href="'tel:' + companyPhone") {{companyPhone}}
          | &nbsp;&nbsp;｜&nbsp;&nbsp;服務信箱&nbsp;
          a(href="mailto:ach@uniform.com.tw") ach@uniform.com.tw
      span.mr-3 &copy; Copyright {{ nowYear }} - ACH Taiwan
    v-layout(hidden-sm-and-up align-center justify-center column style="min-width: 300px;")
      span.mt-3 24 小時服務專線&nbsp;
        a(:href="'tel:' + companyPhone") {{companyPhone}}
      span.my-1 服務信箱
        a(href="mailto:ach@uniform.com.tw") ach@uniform.com.tw
      span.mb-3 &copy; Copyright {{ nowYear }} - ACH Taiwan
</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { global } from 'mixins/global'

export default {
  mixins: [global],
  data () {
    return {
      nowYear: moment().format('YYYY'),
      paddingLeft: '0px'
    }
  },
  created () {
    // 控制 footer 與 main content 的間距
    this.__resizeHanlder = debounce(() => {
      let main = document.getElementById('mainContent')
      this.paddingLeft = main.style.paddingLeft
      main.style.paddingBottom = document.getElementById('mainFooter').clientHeight.toString() + 'px'
    }, 10)
    window.addEventListener('resize', this.__resizeHanlder)
  },
  mounted () {
    window.dispatchEvent(new Event('resize'))
  },
  beforeDestroy () {
    // 移除 監聽視窗大小事件
    window.removeEventListener('resize', this.__resizeHanlder)
  }
}
</script>

<style lang="sass" scoped>
  .layout-footer
    font-size: 12px
    overflow-x: hidden
    position: absolute
    border-top: 1px solid #e6e6e6
    width: 100%
    left: 0
</style>
